import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Api from 'portal-modules/common/api'
import { RequestContentModal } from 'portal-modules/common/components/modals'

import { FocusSpan } from 'portal-modules/common/components/focus-styles'
import { privacyPolicy } from 'portal-modules/common/constants/privacy-policies'
import {
  StyledButton,
  StyledLoginPrivacyButton,
  StyledPrivacyButton,
} from 'portal-modules/common/components/atoms'


const PrivacyPolicy = ({ current_page }) => {
  const [showEntrataPrivacyPolicy, setShowEntrataPrivacyPolicy] =
    useState(false)
  const [entrataPrivacyPolicy, setEntrataPrivacyPolicy] = useState(null)

  const getAllPrivacyPolicies = async () => {
    const {
      primary_privacy_policy,
      secondary_privacy_policy,
      show_entrata_privacy_policy,
    } = await Api.getPrivacyPolicies()

    if (
      !show_entrata_privacy_policy &&
      (primary_privacy_policy.external_url ||
        primary_privacy_policy.privacy_policy_open_text ||
        primary_privacy_policy.privacy_policy_pdf)
    ) {
      const privacyUrl =
        primary_privacy_policy && primary_privacy_policy.external_url
          ? primary_privacy_policy.external_url
          : secondary_privacy_policy &&
            secondary_privacy_policy.external_url &&
            secondary_privacy_policy.external_url

      if (primary_privacy_policy.external_url) {
        window.open(privacyUrl, '_blank').focus()
      } else if (primary_privacy_policy.privacy_policy_open_text) {
        setEntrataPrivacyPolicy(primary_privacy_policy.privacy_policy_open_text)
        setShowEntrataPrivacyPolicy(true)
      } else {
        setEntrataPrivacyPolicy(primary_privacy_policy.privacy_policy_pdf)
        setShowEntrataPrivacyPolicy(true)
      }
    } else {
      setEntrataPrivacyPolicy(privacyPolicy)
      setShowEntrataPrivacyPolicy(true)
    }
  }

  return (
    <>
      <StyledButton
        css={
          current_page === 'login'
            ? StyledLoginPrivacyButton
            : StyledPrivacyButton
        }
        onClick={getAllPrivacyPolicies}
      >
        <FocusSpan>{__('Privacy Policy')}</FocusSpan>
      </StyledButton>
      <RequestContentModal
        title={__('Privacy Policy')}
        show={showEntrataPrivacyPolicy}
        onClose={() => setShowEntrataPrivacyPolicy(false)}
      >
        {entrataPrivacyPolicy}
      </RequestContentModal>
    </>
  )
}

PrivacyPolicy.propTypes = {
  current_page: PropTypes.string,
}

export default PrivacyPolicy
